// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f36a1707","239":"0b420bf6","453":"19399770","732":"d6b839e7"}[chunkId] + ".chunk.js";
};